import { MainLayoutSimple } from "components/layouts/MainLayoutSimple";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const BuyFirstShare = React.lazy(() => import("../page"));

const routes: AppRouteType[] = [
  {
    path: slugs.buyFirstShare,
    component: BuyFirstShare,
    container: MainLayoutSimple,
    isAuthNeeded: true,
  },
];

export default routes;
